import React, { memo } from 'react';
import { Dashboard } from '../../../../../types/files';
import DashboardStatusMenu from '../../../../molecules/dashboard-menus/DashboardStatusMenu';

const StatusCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    return (<>
        <DashboardStatusMenu dashboard={dashboard}  />
    </>);
}

export default memo(StatusCell);
